export default (errors, property) => errors?.data?.errors?.some((err) => err.propertyName === property);
